module.exports = __webpack_public_path__ + "assets/img/img192.83363d13.png";